export class NetworkClassificationFilters {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "_in",
            "baseName": "in",
            "type": "Array<NetworkClassification>",
            "format": ""
        },
        {
            "name": "notIn",
            "baseName": "notIn",
            "type": "Array<NetworkClassification>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return NetworkClassificationFilters.attributeTypeMap;
    }
    constructor() {
    }
}
